import type { ShareOptions } from '@/helpers/linkedin';
import { PEGASUS_MUSTANG_SHARING_NAMESPACE } from '@/settings/constants';
import { ENDPOINTS } from '@/settings/endpoints';
import axios from 'axios';

export class LinkedinService {
  private static readonly redirectURL = `${ENDPOINTS.classrooms}/compartilhar`;

  static generateOAuthURL() {
    const linkedinClientId = process.env.VUE_APP_LINKEDIN_CLIENT_ID as string;

    const oAuthURL = new URL(ENDPOINTS.linkedinOAuth!);
    oAuthURL.searchParams.append('response_type', 'code');
    oAuthURL.searchParams.append('client_id', linkedinClientId);
    oAuthURL.searchParams.append('redirect_uri', this.redirectURL);
    oAuthURL.searchParams.append('scope', 'r_liteprofile%20r_emailaddress%20w_member_social');

    return decodeURIComponent(oAuthURL.href);
  }

  static async sharePost(dexToken: string, postConfig: ShareOptions) {
    const requestBody: ShareOptions = {
      redirectUri: this.redirectURL,
      ...postConfig,
    };

    await axios.post(`${PEGASUS_MUSTANG_SHARING_NAMESPACE}/linkedin/share-post`, requestBody, {
      baseURL: ENDPOINTS.pegasusMustang as string,
      headers: {
        'Authorization-Dex': `Bearer ${dexToken}`,
      },
    });
  }
}
